import { Avatar, Clickable, Wrap, Stack, Typography } from "components";
import { Appointment } from "types";
import { formatDate, formatTimeRange } from "helpers";
import StatusChip from "./StatusChip";

type AppointmentKeys = "startAt" | "endAt" | "status" | "doctor";

interface AppointmentCardProps extends Pick<Appointment, AppointmentKeys> {
  link?: string;
  style?: React.CSSProperties;
}

const AppointmentCard: React.FC<AppointmentCardProps> = ({
  startAt,
  endAt,
  status,
  doctor,
  link,
  style,
}) => {
  const date = formatDate(startAt, { dateStyle: "medium" });
  const time = formatTimeRange(startAt, endAt);

  const itemStyle: React.CSSProperties = {
    flex: 1,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "pre",
  };

  return (
    <Wrap
      if={Boolean(link)}
      with={(children) => (
        <Clickable link={link} style={style}>
          {children}
        </Clickable>
      )}
    >
      <Stack gap={2} placeItems="center">
        <Typography weight={500} style={itemStyle}>
          {date}
        </Typography>

        <Stack style={itemStyle}>
          <StatusChip status={status} />
        </Stack>

        <Typography style={{ ...itemStyle, flex: 1.5 }}>{time}</Typography>

        <Stack
          gap={1.5}
          placeItems="center"
          style={{ ...itemStyle, flex: 2.5 }}
        >
          <Avatar alt={doctor.lastName[0]} src={doctor.image} size="32px" />
          <Typography style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
            {doctor.displayName}
          </Typography>
        </Stack>
      </Stack>
    </Wrap>
  );
};

export type { AppointmentCardProps };
export { AppointmentCard };
